import React from 'react'
import PublicLayout from '~/components/PublicLayout'
import PageNotFound from '~/components/PageNotFound'

const NotFound: React.FC = () => {
  return (
    <PublicLayout>
      <PageNotFound />
    </PublicLayout>
  )
}

export default NotFound
